import {z} from 'zod';

export const scanLicensePlateResponseSchema = z.object({
  licensePlate: z.string().nullable(),
});
